<template>
  <gw-entity-chooser
    class="a7-pessoa-entity-chooser"
    :search="search"
    :disabled="disabled"
    :find-entity-by-id="findEntityByID" representation-field="nome"
    bindByID v-model="computedValue" :selection-support="a7PessoaListing">
    <template slot="item" slot-scope="scope">
      <div class="grupo-buscador">
        <div class="item-header">{{$t('Pessoa.ui.chooser.nome')}} </div>
        <div>{{scope.entity.nome}}</div>
        <div class="item-header">{{$t('Pessoa.ui.chooser.cpfCnpj')}} </div>
        <div> {{scope.entity.cpfCnpj}}</div>
        <div class="item-header">{{$t('Pessoa.ui.chooser.contato')}} </div>
        <div>{{scope.entity.contato}}</div>
      </div>
    </template>
  </gw-entity-chooser>
</template>

<script>
import {
  GwEntityChooser,
  GwGridContainer
} from 'guaxinim-web'
import PessoaRestResource from './PessoaRestResource'
import A7PessoaListing from './A7PessoaListing'

export default {
  name: 'a7-pessoa-entity-chooser',
  components: {
    GwEntityChooser,
    GwGridContainer
  },
  props : {
    value : {
      type: Object | Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      a7PessoaListing: A7PessoaListing
    }
  },
  computed:{
    computedValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    }
  },
  methods: {
    search(pattern) {
      if (!pattern) return null
      return PessoaRestResource.findPessoaFinderDTO(null, pattern, 10)
    },
    findEntityByID(id) {
      return PessoaRestResource.findEntityByID(id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .a7-pessoa-entity-chooser {
    width: 100%;

    & .grupo-buscador {
      display: grid;
      grid-template-columns: 70px 1fr 1fr 112px;
      white-space: normal;
    }

    & .grupo-buscador .item-header{
      font-weight: bolder;
      text-align: right;
      padding-right: 5px;
    }

    & .grupo-buscador div:last-child{
      grid-column: 2/5;
    }
  }
</style>